import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as Api from "../../../api/index.js";


const queryKey = {
    menuLayouts: "getMenuLayouts",
    menuLayout: "getMenuLayout",
}

// Local error handler (mirrors the one in useQueryHooks)
const handleApiError = (response) => {
  if (!response?.success) {
    throw new Error(response?.msg || "An unknown error occurred");
  }
  return response;
};

  const useGetMenuLayout = () => {
    return useQuery({
      queryKey: [queryKey.menuLayouts],
      queryFn: async() => {
        const res = await Api.getMenuUiLayoutConfigs();
        return handleApiError(res);
      },
    });
  }

  const useCreateMenuLayout = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async (data) => {
        const response = await Api.createMenuUiLayoutConfig(data);
        return handleApiError(response);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [queryKey.menuLayouts] });
      },
    });
  }

  const useUpdateMenuLayout = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async ({ id, data }) => {
        const response = await Api.updateMenuUiLayoutConfig(id, data);
        return handleApiError(response);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [queryKey.menuLayouts] });
      },
    });
  }

  const useDeleteMenuLayout = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async (id) => {
        const response = await Api.deleteMenuUiLayoutConfig(id);
        return handleApiError(response);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [queryKey.menuLayouts] });
      },
    });
  }


export const  uiConfigServices = {
    queryKey,
    useGetMenuLayout,
    useCreateMenuLayout,
    useUpdateMenuLayout,
    useDeleteMenuLayout
}
